import React from 'react';
export var ActionsCtx = React.createContext(['']);
//# sourceMappingURL=ActionCtx.js.map